import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';

const WhoItsForSection = () => {
    return (
        <Box
            component="section"
            id="who-its-for"
            aria-labelledby="who-its-for-heading"
            sx={{
                py: { xs: 7, md: 8, lg: 8.5 },
                background: 'linear-gradient(180deg, #F8FAFF 0%, #FFFFFF 55%, #F5F8FF 100%)',
                borderTop: '1px solid rgba(0, 102, 255, 0.08)',
                borderBottom: '1px solid rgba(0, 102, 255, 0.08)',
            }}
        >
            <Container maxWidth="lg">
                <Box sx={{ textAlign: 'center', maxWidth: 720, mx: 'auto'}}>
                    <Typography
                        component="span"
                        sx={{
                            display: 'inline-block',
                            fontSize: { xs: '0.6875rem', sm: '0.75rem' },
                            fontWeight: 700,
                            letterSpacing: '0.18em',
                            textTransform: 'uppercase',
                            color: '#0066FF',
                            bgcolor: 'rgba(0, 102, 255, 0.1)',
                            px: { xs: 1.75, sm: 2.25 },
                            py: 0.75,
                            borderRadius: 999,
                            textAlign: 'center',
                            mb: 2.5,
                        }}
                    >
                        Who it's for
                    </Typography>
                </Box>
                <Typography
                    id="who-its-for-heading"
                    variant="h2"
                    sx={{
                        fontSize: { xs: '1.75rem', sm: '2.125rem', md: '2.5rem' },
                        fontWeight: 800,
                        lineHeight: 1.18,
                        letterSpacing: '-0.03em',
                        color: '#0F172A',
                        mb: 3,
                        // maxWidth: '24ch',
                        textAlign: 'center',
                    }}
                >
                    This is the operation meDZhub was built for
                </Typography>

                <Typography
                    component="p"
                    sx={{
                        fontSize: { xs: '1rem', sm: '1.0625rem', md: '1.125rem' },
                        lineHeight: 1.75,
                        color: 'rgba(15, 23, 42, 0.82)',
                        // maxWidth: '46rem',
                        textAlign: 'center',
                        m: 0,
                    }}
                >
                    Field staff visiting patients at home. In-house sessions running the same day.
                    Coordination buried in calls and messages. Visits you couldn't confirm, records
                    that didn't hold up, payment cycles that dragged.
                </Typography>

                <Typography
                    component="p"
                    sx={{
                        mt: 2.5,
                        fontSize: { xs: '1rem', sm: '1.0625rem', md: '1.125rem' },
                        lineHeight: 1.72,
                        color: 'rgba(15, 23, 42, 0.82)',
                        // maxWidth: '46rem',
                        textAlign: 'center',
                    }}
                >
                    If this is what your operation looks like, meDZhub was built for it.
                </Typography>

                <Box sx={{ mt: { xs: 4, md: 3.5 }, textAlign: 'center' }}>
                    <Button
                        variant="contained"
                        href="#contact"
                        sx={{
                            textTransform: 'none',
                            borderRadius: 999,
                            px: 3.25,
                            py: 1.2,
                            fontSize: { xs: '0.95rem', md: '1rem' },
                            fontWeight: 600,
                            background: 'linear-gradient(135deg, #0066FF 0%, #4F46E5 100%)',
                            boxShadow: '0 10px 26px rgba(0, 102, 255, 0.26)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #0052CC 0%, #4338CA 100%)',
                            },
                        }}
                    >
                        See it in action
                    </Button>
                </Box>

                <Box
                    sx={{
                        mt: { xs: 4, md: 4.5 },
                        pt: { xs: 2.5, md: 3 },
                        borderTop: '1px solid rgba(15, 23, 42, 0.08)',
                        maxWidth: 860,
                        mx: 'auto',
                        textAlign: 'center',
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: { xs: '1.05rem', md: '1.2rem' },
                            fontWeight: 700,
                            color: '#0F172A',
                            mb: { xs: 2.5, md: 3 },
                            letterSpacing: '-0.02em',
                        }}
                    >
                        Same problem, different setup?
                    </Typography>

                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                            gap: { xs: 2, md: 2.5 },
                        }}
                    >
                        <Box
                            sx={{
                                p: { xs: 2, md: 2.5 },
                                border: '1px solid rgba(0, 102, 255, 0.12)',
                                borderRadius: 2.5,
                                backgroundColor: '#FFFFFF',
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: { xs: '0.95rem', md: '1rem' },
                                    lineHeight: 1.6,
                                    color: 'rgba(15, 23, 42, 0.85)',
                                    mb: 1.5,
                                }}
                            >
                                Running home visits on your own?
                            </Typography>
                            <Button
                                variant="text"
                                href="#how-it-works"
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 700,
                                    color: '#0066FF',
                                    p: 0,
                                    minWidth: 'auto',
                                    '&:hover': { backgroundColor: 'transparent', color: '#0052CC' },
                                }}
                            >
                                See how it works for solo practitioners
                            </Button>
                        </Box>

                        <Box
                            sx={{
                                p: { xs: 2, md: 2.5 },
                                border: '1px solid rgba(0, 102, 255, 0.12)',
                                borderRadius: 2.5,
                                backgroundColor: '#FFFFFF',
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: { xs: '0.95rem', md: '1rem' },
                                    lineHeight: 1.6,
                                    color: 'rgba(15, 23, 42, 0.85)',
                                    mb: 1.5,
                                }}
                            >
                                Managing post-discharge rehab for a hospital?
                            </Typography>
                            <Button
                                variant="text"
                                href="/platform"
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 700,
                                    color: '#0066FF',
                                    p: 0,
                                    minWidth: 'auto',
                                    '&:hover': { backgroundColor: 'transparent', color: '#0052CC' },
                                }}
                            >
                                See how it works for your programme
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default WhoItsForSection;
